/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.support.portal.rpc.AttachmentsRpc
 */

export const ConsentErrorDiscriminant = 'CONSENT';
export const ConsentErrorDiscriminantKey = '@type';
export const CustomerSuccessPortalErrorDiscriminant = 'CUSTOMER_SUCCESS_PORTAL';
export const CustomerSuccessPortalErrorDiscriminantKey = '@type';
export const NotificationErrorDiscriminant = 'NOTIFICATION';
export const NotificationErrorDiscriminantKey = '@type';
export const PortalAuthErrorDiscriminant = 'AUTH';
export const PortalAuthErrorDiscriminantKey = '@type';
export const PortalPublicRpcErrorDiscriminantKey = '@type';
export const SettingsErrorDiscriminant = 'SETTINGS';
export const SettingsErrorDiscriminantKey = '@type';
export const SupportPortalErrorDiscriminant = 'SUPPORT_PORTAL';
export const SupportPortalErrorDiscriminantKey = '@type';
export const TrackEventErrorDiscriminant = 'TRACK_EVENT';
export const TrackEventErrorDiscriminantKey = '@type';
export const TranslationsErrorDiscriminant = 'TRANSLATIONS';
export const TranslationsErrorDiscriminantKey = '@type';
export const getUploadTokenRpc = {
  serviceName: 'com.hubspot.support.portal.rpc.AttachmentsRpc',
  rpcName: 'getUploadToken',
  auth: 'external',
  fingerprint: 'wvG5jF-zW-k6soe-lQ4sZ3OjsnBdk3FP',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getThreadAttachmentsRpc = {
  serviceName: 'com.hubspot.support.portal.rpc.AttachmentsRpc',
  rpcName: 'getThreadAttachments',
  auth: 'external',
  fingerprint: '7j0El6PQ3sbOBnbx3Ebwm3OjsnBdk3FP',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};